import React from "react";
import { PageHero, PageBody } from "./_shared";
import { useFood } from "./FoodLayout";
import { Link2, ExternalLink, FileText } from "lucide-react";

export default function ImportantLinks() {
  const data = useFood();
  const links = data.links || [];
  return (
    <div data-testid="ft-links">
      <PageHero eyebrow="Resources" title="Important Links" />
      <PageBody>
        {links.length === 0 ? (
          <div className="bg-white rounded-lg p-12 text-center text-sm text-[#4D5A52] ring-1 ring-[#E6E2D6]">
            Important links will appear here once published by the institute.
          </div>
        ) : (
          <div className="grid md:grid-cols-2 gap-4">
            {links.map((l) => {
              const url = l.file_url || l.external_url;
              const isPdf = !!l.file_url;
              return (
                <a key={l.id} href={url || "#"} target="_blank" rel="noopener noreferrer"
                   className="bg-white rounded-md p-5 ring-1 ring-[#E6E2D6] hover:ring-[#F4751F] transition-colors flex items-start gap-3">
                  {isPdf ? <FileText className="text-[#C95507] mt-0.5" size={20} /> : <Link2 className="text-[#1F6B3F] mt-0.5" size={20} />}
                  <div className="flex-1 min-w-0">
                    <div className="text-sm font-medium text-[#0F1F17]">{l.title}</div>
                    {l.description && <p className="mt-1 text-[12px] text-[#4D5A52]">{l.description}</p>}
                  </div>
                  <ExternalLink size={14} className="text-[#4D5A52]" />
                </a>
              );
            })}
          </div>
        )}
      </PageBody>
    </div>
  );
}
